<div class="approval-rule-table__wrapper">
  <table class="lum-table lum-table--classic striped">
    <tr class="table__head-row">
      <th>ID</th>
      <th>Name</th>
      <th>Model</th>
      <th>&nbsp;</th>
    </tr>
    <tbody>
      <tr *ngFor="let row of data; trackBy: trackById; let i = index">
        <td>{{ row.id }}</td>
        <td>{{ row.name }}</td>
        <td>{{ row.model | approvalRuleModel }}</td>
        <td class="flex justify-content-end">
          <div class="btn-group">
            <button
              type="button"
              class="lum-button lum-button--tertiary lum-button--small mr-2"
              mat-button
              (click)="editEvent.emit(row.id)"
            >
              Edit
              <lum-ui-icon
                class="ml-2"
                icon="edit"
                [width]="24"
                [height]="24"
                color="#5563D6"
              ></lum-ui-icon>
            </button>

            <button
              type="button"
              class="lum-button lum-button--tertiary lum-button--small"
              mat-button
              (click)="deleteEvent.emit(row.id)"
            >
              Delete
              <lum-ui-icon
                class="ml-2"
                icon="close-circle"
                [width]="24"
                [height]="24"
                color="#fd397a"
              ></lum-ui-icon>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
